// extracted by mini-css-extract-plugin
export var bold = "Slide-module--bold--9645a";
export var content = "Slide-module--content--bb6ed";
export var img = "Slide-module--img--2c5c4";
export var title = "Slide-module--title--bf8e2";
export var wrapper = "Slide-module--wrapper--eb47e";